__turbopack_context__.v({
  "container": "product-module__VsZ0nq__container",
  "header": "product-module__VsZ0nq__header",
  "mainContent": "product-module__VsZ0nq__mainContent",
  "price": "product-module__VsZ0nq__price",
  "priceLabel": "product-module__VsZ0nq__priceLabel",
  "priceSection": "product-module__VsZ0nq__priceSection",
  "productName": "product-module__VsZ0nq__productName",
  "sidebar": "product-module__VsZ0nq__sidebar",
});
